import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	container: {
		alignItems: 'center',
		border: `1px dashed ${THEME.colors.gray.muted}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.lg,
	},
	icon: {
		color: THEME.colors.gray.muted,
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: 600,
		margin: 0,
	},
	subtitle: {
		color: THEME.colors.gray.muted,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
		textAlign: 'center',
	},
});
